import React from 'react';
import './Returns.css';
import Footer from '../../components/Footer/Footer';
import imgss from "../../assets/images/kidss.avif";

const Returns = () => {
    return (
        <>
                  <img src={imgss} alt="" className='abtimg cuim' />
        <div className="return-container">
            <div className="return-content">
             
<h1 className='ourc'>Return Policy</h1>



                <div className="return-section">
                    <p className="return-text">
                        At Swarna Prakash Jewellers, we generally do not accept exchanges or returns. The only
                        exception is for products that are <strong>damaged upon arrival</strong>.
                    </p>

                    <p className="return-text">
                        To be eligible for a return due to damage, the customer <strong>must record the unboxing
                            of the item</strong>. If damage is clearly visible during this unboxing video, we will
                        accept the return.
                    </p>

                    <p className="return-text">
                        The customer will then need to ship the item back to us using an <strong>insured parcel
                            method</strong>. We will bear the cost of this return shipping if the damage is confirmed
                        to have occurred during the original shipment.
                    </p>

                    <p className="return-text">
                        Returns for damaged items must be initiated <strong>immediately upon receipt</strong> of
                        the product, not after several days. The item must be <strong>unworn</strong> and returned
                        with <strong>all original packaging and billing</strong>.
                    </p>

                    <p className="return-text">
                        Return authorization and detailed instructions will be provided once the damage claim has
                        been validated.
                    </p>
                </div>
            </div>
        </div>
        <Footer />
        </>
    );
};


export default Returns;
